import { Card, CardActionArea, Stack, Typography } from "@mui/material";
import { Spacing } from "Infrastructure/Themes/Themes";
import type { FC, ReactNode } from "react";

type Props = {
  title: string;
  subtitle?: string;
  // the record's type, left of the title, e.g. a briefcase for an employment income
  icon?: ReactNode;
  onClick: () => void;
  children: ReactNode;
};

// A record that opens on a click, e.g. an asset: the package card, its border turning primary under the pointer as on
// the goal cards, the whole card a button
export const Tile: FC<Props> = ({ title, subtitle, icon, onClick, children }) => (
  <Card sx={{ transition: "border-color 150ms", "&:hover": { borderColor: "primary.main" } }}>
    <CardActionArea onClick={onClick} sx={{ p: Spacing.XL }}>
      <Stack direction="row" spacing={Spacing.L} alignItems="flex-start">
        {icon}

        <Stack spacing={Spacing.M} minWidth={0} flex={1}>
          <Stack spacing={Spacing.XS}>
            <Typography variant="body2" fontWeight={600}>
              {title}
            </Typography>
            {subtitle && (
              <Typography variant="caption" color="text.secondary">
                {subtitle}
              </Typography>
            )}
          </Stack>

          {children}
        </Stack>
      </Stack>
    </CardActionArea>
  </Card>
);
